/** Stored URLs are often bare hosts ("acme.no"); make them linkable. */
export function ensureHttps(url: string | null | undefined): string | null {
  if (!url) return null;
  return url.startsWith("http") ? url : `https://${url}`;
}
